module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-Italic.022ad19.eot";